import React, { Component, Fragment, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table } from "react-bootstrap";
import {
  Container,
  Button,
  Form,
  Collapse,
  Col,
  Row, Accordion
} from "react-bootstrap";
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { UserProfile } from "../userProfile/userProfile";
import { Link } from "react-router-dom";
import { logoutUser } from "../login/loginApi";
import { getAnomalyForPerformerUser } from "../anomalyRegistration/anomalyApi";


var validatedType = {
  SECURITY: "Безопасность",
  MINOR: "Незначительное",
  BASIC_CONDITION: "Базовое состояние",
  QUALITY: "Качество",
  POLLUTION: "Загрязнение",
  HARD_TO_REACH: "Труднодоступное"
}
var validatedStatus = {
  OPENED: "Открытая",
  CLOSED: "Закрытая",
  OPEN: "Открытая",
  CLOSE: "Закрытая"
}



export function UserView() {
  const log = useSelector((state) => state.login)
  const user = useSelector((state) => state.user)
  const dispatch = useDispatch()

  let table = (<Fragment></Fragment>)

  if (!user.tasks && user.username) {
    dispatch(getAnomalyForPerformerUser({ username: user.username, token: log.token }))
  }

  return (
    <Fragment>
      <UserProfile />
      <div className="mx-auto mt-3 vstack gap-3">
        <Button variant="outline-dark" as={Link} to="/anomaly" >Регистрация аномалии</Button>
        <Button variant="outline-dark" as={Link} to="/anomaly-chart" >Отчеты по аномалиям</Button>
        <Button variant="outline-dark" as={Link} to="/db" >База данных</Button>
        <Button variant="outline-dark" as={Link} to="/support" >Поддержка</Button>

      </div>
      <div className="d-grid mt-3">
        <a role="button" onClick={() => dispatch(logoutUser(log))} data-rr-ui-event-key="login" className="btn btn-dark">Выйти</a>
      </div>
    </Fragment>


  )
}
